// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useFetchCompressionBookingsQuery } from 'apis/compressions_user/compressionUserApi';
import styles from './ShipmentQR.module.scss';
import CompressionBooking from '../CompressionBooking';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { CompressionSiteType } from 'util/Enums';

const ShipmentQR = () => {
  const user = useSelector(selectUser);
  const isStorage = user?.siteType === CompressionSiteType.Storage;

  const { data } = useFetchCompressionBookingsQuery();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className="scroll-contents">
          <CompressionBooking
            compressions={data?.bookingDeliveries || []}
            isStorage={isStorage}
          />
        </div>
      </div>
    </div>
  );
};

export default ShipmentQR;
